// ─── Footer: Minimal ──────────────────────────────────────────
// Ultra-minimal footer with just names and a subtle divider.

import React from 'react';
import { AnimatedSection } from '../../../lib/animations/AnimatedSection';

export default function FooterMinimal({ section, data, theme }) {
  const anim = section.animation || {};

  return (
    <section className="px-5 py-20 text-center" data-testid="footer-section">
      <div className="max-w-xs mx-auto">
        <AnimatedSection preset={anim.section || 'fade-in'}>
          <div className="w-10 h-px mx-auto mb-6" style={{ background: theme.border }} />
          <h2
            className="text-xl font-light"
            style={{ color: theme.textPrimary, fontFamily: theme.headingFont }}
          >
            {data.names || 'See you there'}
          </h2>
          {data.closingMessage && (
            <p className="text-xs mt-3" style={{ color: theme.textSecondary, fontFamily: theme.eyebrowFont }}>
              {data.closingMessage}
            </p>
          )}
          <p className="mt-8 text-[10px]" style={{ color: theme.textSecondary, opacity: 0.4, fontFamily: theme.eyebrowFont }}>
            {data.contactText || 'Made with love'}
          </p>
        </AnimatedSection>
      </div>
      <div className="h-16" />
    </section>
  );
}
